import _ from 'lodash'
import React, { useEffect, useState } from 'react'

import CardStats from 'components/Cards/CardStats.js'
import apiService from 'apiService'
import helpers from 'helpers'
import CardStoreStats from './CardStoreStats'

export default function CardStoresSumStats({ storeId, startDate, endDate, update }) {
    const [initialSales, setInitialSales] = useState(0)
    const [finalSales, setFinalSales] = useState(0)
    const [winnings, setWinnings] = useState(0)
    const [percentage, setPercentage] = useState(0)

    const getStoreSums = async () => {
        const payload = {
            startDate: startDate,
            endDate: endDate
        }
        const results = await apiService.post(`/stats/store/${storeId}/summary-sales`, payload)
        if (!results) return

        setInitialSales(_.round(results.initial, 2))
        setFinalSales(_.round(results.final, 2))
        setWinnings(_.round(results.winning, 2))
        setPercentage(_.round(results.percentage, 2))
    }

    useEffect(() => {
        if (!storeId) return
        getStoreSums()
    }, [update])
    return (
        <>
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6  rounded-lg bg-blueGray-100 border-0">
                <div className="flex flex-wrap">
                    <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                        <CardStoreStats statSubtitle="ΠΩΛΗΣΕΙΣ" statTitle={initialSales} statIconName="fas fa-coins" statIconColor="bg-red-500" />
                    </div>
                    <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                        <CardStoreStats statSubtitle="Τ. ΠΩΛΗΣΕΙΣ" statTitle={finalSales} statIconName="fas fa-money-bill" statIconColor="bg-orange-500" />
                    </div>
                    <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                        <CardStoreStats statSubtitle="ΩΦΕΛΙΜΟ" statTitle={winnings} statIconName="fas fa-minus" statIconColor="bg-emerald-500" />
                    </div>
                    <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                        <CardStoreStats statSubtitle="ΠΟΣΟΣΤΟ" statTitle={percentage} statIconName="fas fa-percent" statIconColor="bg-lightBlue-500" />
                    </div>
                </div>
            </div>
        </>
    )
}
